import { useState } from 'react';

import { withStyles } from '@material-ui/core/styles';

import EditForm from './maintainer/edit';
import LoginForm from './login-form';
import Service from './../services/user-service';
import { isRequired, isValidEmail } from '.././libraries/validators';
import { reduceSpaces } from './../libraries/utils';
import { INCORRECT_EMAIL_TEXT } from './../libraries/texts';
import { MAX_LOGIN_ATTEMPTS } from './../libraries/constants';
import { LOGIN_PASS, MAX_LOGIN_ATTEMPTS_MESSAGE } from './../libraries/texts';
import { editionMaintainer as styles } from './maintainer/styles';

const Login = props => {
  const { classes } = props;
  const service = Service;
  const [attempts, setAttempts] = useState(1);

  const getErrors = values => {
    const errors = {};
    const minimumValues = { username: values.username };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    newValues.password = values.password;
    isRequired(errors, newValues);
    if (!isValidEmail(values.username)) {
      errors.username = INCORRECT_EMAIL_TEXT;
    }
    return errors;
  };

  const errorWrapper = props => err => {
    const { setFieldError } = props;
    setAttempts(attempts + 1);
    const val = 'password';
    let message = '';
    if (err) {
      message = err.includes(val) ? LOGIN_PASS : '';
    } else {
      message = LOGIN_PASS;
    }
    message = attempts >= MAX_LOGIN_ATTEMPTS ? MAX_LOGIN_ATTEMPTS_MESSAGE : message;
    setFieldError(val, message);
  };

  const redirectListPage = () => '/';

  return {
    getErrors,
    errorWrapper,
    service: { ...service, post: service.login, redirectListPage },
    keyName: 'code',
    buttonName: 'Ingresar',
    finalMessageAfterRequest: '',
    buttonClass: classes.loginActions,
    containerClass: classes.withoutContainer
  };
};

export default withStyles(styles)(EditForm(Login)(LoginForm));
